import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import Main from '../components/Main';
import Seo from '../components/Seo';
import Container from '../components/Container';
import Downloads from '../components/Downloads';
import SharePrice from '../components/SharePrice';
import ShareDetails from '../components/ShareDetails';

function Investor({ data }) {
  const {
    pageTitle,
    announcements,
    news,
    annualReports,
    quarterlyReports,
    governance,
    shareDetails,
    presentations,
    metaDescription,
  } = data.allMarkdownRemark.edges[0].node.frontmatter;
  const { fields } = data.allMarkdownRemark.edges[0].node;
  const shareData = data;
  return (
    <Layout>
      <Seo title={pageTitle} description={metaDescription} slug={fields.slug} />
      <Main>
        <Container>
          <div className="pageHeader">
            <h1 className="heading1">{pageTitle}</h1>
          </div>
        </Container>
        <SharePrice data={shareData} />
        <Downloads title="Announcements" downloads={announcements} />
        <Downloads title="News" downloads={news} modifyer="sectionRomantic" />
        <Downloads title="Annual Reports" downloads={annualReports} />
        <Downloads
          title="Quarterly Reports"
          downloads={quarterlyReports}
          modifyer="sectionRomantic"
        />
        <Downloads title="Governance" downloads={governance} />
        <Downloads
          title="Presentations"
          downloads={presentations}
          modifyer="sectionRomantic"
        />
        <ShareDetails shareDetails={shareDetails} />
      </Main>
    </Layout>
  );
}

export default Investor;

export const query = graphql`
  query {
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "investor" } } }
    ) {
      edges {
        node {
          frontmatter {
            pageTitle
            metaDescription
            announcements {
              documentTitle
              documentFile {
                publicURL
              }
              archive
            }
            news {
              documentTitle
              documentFile {
                publicURL
              }
            }
            annualReports {
              documentTitle
              documentFile {
                publicURL
              }
            }
            governance {
              documentTitle
              documentFile {
                publicURL
              }
              archive
            }
            quarterlyReports {
              documentTitle
              documentFile {
                publicURL
              }
              archive
            }
            shareDetails {
              leftcol
              rightcol
            }
            presentations {
              documentTitle
              documentFile {
                publicURL
              }
            }
          }
          fields {
            slug
          }
        }
      }
    }
  }
`;
